export default __webpack_public_path__ + "fe953d8b11eae04e10d404d555d2a176.svg";